'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var motion = require('../theme/motion.js');
require('../hooks/useClickAway.js');
var scrollLock = require('../utils/scrollLock.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  ", ": 0;\n  background-color: white;\n  height: 100%;\n  min-width: ", ";\n  max-width: ", ";\n  overflow: scroll;\n  box-shadow: ", "px 0 4px\n    rgba(0, 0, 0, 0.15);\n  transform: ", ";\n  transition: transform ", " ", ";\n  z-index: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: black;\n  z-index: ", ";\n  opacity: ", ";\n  transition: opacity ", " linear;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Shadow = styled__default['default'].div(_templateObject(), function (props) {
  return props.zIndex || 9;
}, function (props) {
  return props.visible ? '0.6' : '0';
}, motion.durationSlow);
var Content = styled__default['default'].div(_templateObject2(), function (props) {
  return props.position;
}, function (props) {
  return props.width;
}, function (props) {
  return props.width;
}, function (props) {
  return props.position === 'left' ? '2' : '-2';
}, function (props) {
  return props.open ? '' : "translateX(".concat(props.position === 'left' ? '-' : '', "100%)");
}, motion.durationSlow, motion.easeBaseOut, function (props) {
  return props.zIndex || 9;
});
/**
 * IMPORTANT
 *
 * - Why you don't want to scroll body scroll at the
 *   component level - scroll is locked based on
 *   wether `open` changes. If you plan on
 *   pushing routes without closing the drawer,
 *   scroll will still be enabled on the other
 *   route.
 *
 */

var Drawer = function Drawer(_ref) {
  var propVisible = _ref.visible,
      children = _ref.children,
      showOverlay = _ref.showOverlay,
      closeOnClick = _ref.closeOnClick,
      closeOnClickAway = _ref.closeOnClickAway,
      zIndex = _ref.zIndex,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      lockBodyScroll = _ref.lockBodyScroll,
      restProps = _objectWithoutProperties(_ref, ["visible", "children", "showOverlay", "closeOnClick", "closeOnClickAway", "zIndex", "onOpen", "onClose", "lockBodyScroll"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1]; // Dummy variable to track animation end


  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  React.useEffect(function () {
    setVisible(propVisible);

    if (propVisible) {
      setOpen(true);
      lockBodyScroll && scrollLock['default'](true);
    } else {
      lockBodyScroll && scrollLock['default'](false);
    }
  }, [propVisible]); // let ref = useClickAway(() => closeOnClickAway && setVisible(false))

  if (!propVisible && !open) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, showOverlay ? /*#__PURE__*/React__default['default'].createElement(Shadow, {
    onClick: function onClick() {
      return closeOnClickAway && setVisible(false);
    },
    zIndex: zIndex,
    visible: visible
  }) : null, /*#__PURE__*/React__default['default'].createElement(Content, _extends({}, restProps, {
    onTransitionEnd: function onTransitionEnd() {
      if (visible) {
        onOpen && onOpen();
      } else {
        setOpen(false);
        onClose && onClose();
      }
    },
    open: visible // ref={ref}
    // onClick={(event) => {
    //   closeOnClick &&
    //     !event.target.isEqualNode(ref.current) &&
    //     setVisible(false)
    // }}
    ,
    zIndex: zIndex
  }), children));
};

Drawer.propTypes = {
  position: PropTypes__default['default'].oneOf(['left', 'right']),
  onOpen: PropTypes__default['default'].func,
  onClose: PropTypes__default['default'].func,
  width: PropTypes__default['default'].string,
  showOverlay: PropTypes__default['default'].bool,
  closeOnClick: PropTypes__default['default'].bool,
  closeOnClickAway: PropTypes__default['default'].bool,
  visible: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node,
  zIndex: PropTypes__default['default'].number,
  className: PropTypes__default['default'].string,
  lockBodyScroll: PropTypes__default['default'].bool
};
Drawer.defaultProps = {
  position: 'right',
  showOverlay: true,
  width: '420px',
  closeOnClick: false,
  closeOnClickAway: true,
  lockBodyScroll: true
};

exports.default = Drawer;
